/** @jsx jsx */
import {Fragment, useMemo} from 'react'
import {OptionsType, ValueType} from 'react-select'
import {jsx} from 'theme-ui'
import CustomSelect, {ISelectOption} from './CustomSelect'
import {DonationPurpose, DISABLED_DONATION_PURPOSES} from './shared'
import {useTranslation} from 'react-i18next'

interface IDonationPurposeBlock {
  donationPurpose: DonationPurpose
  setDonationPurpose: (donationPurpose: DonationPurpose) => void
}

const DonationPurposeBlock: React.FC<IDonationPurposeBlock> = ({
  donationPurpose,
  setDonationPurpose,
}) => {
  const {t} = useTranslation()
  const donationPurposeOptions: OptionsType<ISelectOption> = useMemo(
    () =>
      Object.keys(DonationPurpose)
        .filter(
          (_donationPurpose) =>
            !DISABLED_DONATION_PURPOSES.includes(
              _donationPurpose as DonationPurpose,
            ),
        )
        .map((purpose) => ({
          value: purpose,
          label: t(purpose),
        })),
    [t],
  )
  const donationPurposeOption:
    | ISelectOption
    | undefined = donationPurposeOptions.find(
    ({value}) => value === donationPurpose,
  )
  const handleDonationPurposeChange = (newValue: ValueType<ISelectOption>) => {
    if (newValue && 'value' in newValue)
      setDonationPurpose(newValue.value as DonationPurpose)
  }

  return (
    <Fragment>
      <h2
        sx={{
          fontSize: 12,
          fontWeight: 400,
          textTransform: 'uppercase',
          color: 'grey',
        }}
      >
        {t('donationBoxTitle')}
      </h2>
      <CustomSelect
        options={donationPurposeOptions}
        sx={{
          fontSize: 14,
          color: '#3A3E3F',
          borderRadius: 4,
        }}
        onChange={handleDonationPurposeChange}
        value={donationPurposeOption}
      />
    </Fragment>
  )
}

export default DonationPurposeBlock
